import {
  SetAppointmentAction,
  SET_APPOINTMENT_METADATA,
  CLEAR_APPOINTMENTS,
  UserActionTypes,
} from '../../types/appointmentActions';

const defaultState: { appointments: any } = { appointments: {} };

export default function (
  state = defaultState,
  action: UserActionTypes,
): { appointments: {} } {
  switch (action.type) {
    case SET_APPOINTMENT_METADATA:
      return {
        ...state,
        appointments: {
          ...state.appointments,
          ...action.payload
        },
      };
    case CLEAR_APPOINTMENTS:
      return {
        ...state,
        appointments: {}
      };
    default:
      return state;
  }
}
